export default __webpack_public_path__ + "static/media/lion@3x.8fa972a2.png";